import gql from "graphql-tag";

export const refreshAccessTokenMutation = gql`
  mutation refreshAccessToken($refreshToken: String!) {
    refreshAccessToken(refreshToken: $refreshToken) {
      success
      errorMessage
      accessToken
      tokenType
      expiresIn
      expireTime
      refreshToken
    }
  }
`;
